import React, { useState, useEffect, useRef, useContext } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import axios from "axios";
import Footer from "../Footer";
import { contentContext } from "../../context/contentContext";
import Loader from "../../components/loader";
import { useNavigate } from "react-router-dom";
import tmdbApi from "../../api/tmdbApi";
import SessionPopup from "../SessionPopup";
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';

let { lambda, appname } = window.app;

const FM = ({ type }) => {

    const [data, setData] = useState([]);
    const [tagsPrepared, setTagsPrepared] = useState(false);
    const [tagCarousels, setTagCarousels] = useState([]);
    const [activeVideo, setActiveVideo] = useState(null);
    const [inputQuery, setInputQuery] = useState('');
    const [query, setQuery] = useState('');
    const [searchField, setSearchField] = useState('title');
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const { GetTimeActivity, isLoading, setIsLoading, userData } = useContext(contentContext);
    const [selectedTag, setSelectedTag] = useState(-1);
    const [razorpayKey, setRazorpayKey] = useState(null);
    const [errorMsg, setErrorMsg] = useState(false);
    const [options, setOptions] = useState([]); // dropdown list (label/value)
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);

    const navigate = useNavigate();
    const itemsPerPage = 12;
    const token = localStorage.getItem("token");
    const backTpPrev = () => {
        navigate(-1); // go back
    }

    const [activeReadMoreModal, setActiveReadMoreModal] = useState(false);
    const [modalContent, setModalContent] = useState("");

    useEffect(() => {
        // if (!localStorage.getItem("token")) {
        //     navigate("/");
        // }
        const fetchConfigAndTags = async () => {
            const response = await tmdbApi.configData();
            if (response?.result && response?.result.length > 0) {
                setRazorpayKey(response?.result[0]?.RAZORPAY_KEY_ID);
            }
            // await getTagAPI();
            await getTags();
            window.scrollTo(0, 0);
        };
        fetchConfigAndTags();
        fetchLibraryData(query, currentPage);
    }, [type]);


    // console.log('dddddddddddddddddddddd',data)

    const getTags = (e) => {
        GetTimeActivity()
        const userId = localStorage.getItem("userId")
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/tagInfo?appname=' + appname + '&type=videoTag',

            // + '&token=' + token,
        })
            .then(function (response) {
                console.log("response tagsssssssssssss", response?.data?.result);

                const list = response?.data?.result?.map((tag) => tag.name

                );

                console.log('list', list)
                setOptions(list);


            });
    }

    const getTagAPI = async () => {
        let result = await tmdbApi.librarytaginfo(type);
        if (result?.result === "Invalid token or Expired") {
            // handle invalid token if needed
            setIsLoading(false)
            setShowSessionPopupup(true)
        } else if (result?.result?.length > 0) {
            setTagCarousels(result?.result?.sort());
            setTagsPrepared(true);
        } else {
            setTagCarousels([]);
            setTagsPrepared(false);
        }
    };


    useEffect(() => {

        fetchLibraryData(query, currentPage);
    }, [query, currentPage]);


    const clearSearch = () => {
        setInputQuery('');
        setQuery('');
        setSelectedTag(-1);
        setCurrentPage(1);
        fetchLibraryData('', 1);
    };


    const submitData = () => {
        console.log('sssssssssssss', inputQuery)
        if (inputQuery.trim().length === 0 || inputQuery === "") {
            toast.error("Search field cannot be empty.");

            return;
        }
        setSelectedTag(-1);
        setCurrentPage(1);
        setQuery(inputQuery);
    };


    console.log('isloading,',isLoading)

    const fetchLibraryData = (searchQuery = '', page = 1) => {
        setIsLoading(true);
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")
        let params = {
            appname,
            assetcount: itemsPerPage,
            pageNumber: page,
            search: searchQuery,
            token: token,
            pageName: 'ACTIVE',
            type: "Learning Module",
            moduleType: "subscription",
            userid: userid,
            submodule: "FELLOWSHIP"

        }


        axios
            .get(`${lambda}/moduleInfo`, {
                params: params
            })
            .then((response) => {
                const result = response?.data?.result;
                if (result === "Invalid token or Expired") {
                    // handle invalid token if needed
                    setIsLoading(false)
                    setShowSessionPopupup(true)
                    return;
                }
                // if (result?.data && Array.isArray(result.data)) {
                //     setData(result.data);

                //     let totalPagesTmp = Math.ceil(result.totalCount / itemsPerPage);

                //     if (searchQuery) {
                //         totalPagesTmp = Math.ceil(result.data.length / itemsPerPage);
                //     }
                //     setTotalPages(totalPagesTmp);

                // } else {
                //     setData([]);
                //     setTotalPages(0);
                // }
                console.log("API Response:", result);
                setData(result?.data || []);
                setTotalPages(Math.ceil(result?.totalCount / itemsPerPage) || 0);
                setIsLoading(false)
            })
            .catch((err) => console.error("API error:", err))
            .finally(() => setLoading(false));
    };
    // let tags = [];
    // const prepareTags = (videoData) => {
    //     videoData.forEach(item => {
    //         if (Array.isArray(item.tags)) {
    //             tags = tags.concat(item.tags);
    //         }
    //     });
    //     const latest = [...new Set(tags)];
    //     setTagCarousels(latest);
    // };

    const getYouTubeVideoId = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url?.match(regExp);
        return match && match[7].length === 11 ? match[7] : null;
    };
    const [img, setImg] = useState(null)
    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);
    const [usrData, setusrData] = useState(null);
    const formatDate = (dateValue) => {
        const date = new Date(dateValue);

        // if invalid date → return placeholder
        if (isNaN(date.getTime())) {
            return "--/--/----";
        }

        // return formatted date
        return date.toLocaleDateString();
    };

    useEffect(() => {
        setusrData(userData)
    }, [userData]);
    console.log("usrData", usrData);

    const TagCarousel = () => {
        const carouselRef = useRef(null);
        const step = 100;

        const handleNext = () => {
            if (carouselRef.current) {
                carouselRef.current.scrollBy({ left: step, behavior: 'smooth' });
            }
        };

        const handlePrev = () => {
            if (carouselRef.current) {
                carouselRef.current.scrollBy({ left: -step, behavior: 'smooth' });
            }
        };

        return (
            <div className="tag-carousel-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
                <button className="tag-carousel-btn" onClick={handlePrev}>&#8249;</button>
                {/* <div
                    className="tag-carousel"
                    style={{
                        overflowX: 'auto',
                        scrollBehavior: 'smooth',
                        display: 'flex',
                        flexWrap: 'nowrap',
                        gap: '10px',
                        padding: '10px 0',
                        flex: 1
                    }}
                    ref={carouselRef}
                > */}
                {/* <div
                        className={selectedTag === -1 ? "tag-active" : "tag"}
                        onClick={() => {
                            setSelectedTag(-1);
                            setInputQuery('');
                            setQuery('');
                            setCurrentPage(1);
                            fetchLibraryData('', 1);
                        }}
                        style={{ cursor: "pointer" }}
                    >
                        All
                    </div> */}
                {/* {options.map((itm, idx) => (
                        <div
                            key={idx}
                            className={selectedTag === idx ? "tag-active" : "tag"}
                            onClick={() => {
                                setSelectedTag(idx);
                                // setInputQuery(itm);
                                setQuery(itm);
                                setCurrentPage(1);
                                fetchLibraryData(itm, 1);
                            }}
                            style={{ cursor: "pointer" }}
                        >
                            {itm}
                        </div>
                    ))} */}
                {/* </div> */}
                {/* <button className="tag-carousel-btn" onClick={handleNext}>&#8250;</button> */}
            </div>
        );
    };
    const [showBuyAlert, setShowBuyAlert] = useState(false);
    const [buyModuleItem, setBuyModuleItem] = useState(null);
    const okayErrorFn = () => {
        setErrorMsg(false);
        clearSearch()
    }
    const handleUserClick = (item) => {


        

        console.log('itemmmmmmmmmm', item)

        localStorage.setItem('usermodule', "usermodule")
        if (!token) {
            navigate("/login");
            // localStorage.setItem("moduleid", item?.moduleid);
            return;
        }
        if (item?.cost !== 0 && item?.isPurchased === false) {
            setBuyModuleItem(item);
            setShowBuyAlert(true);
        } 

        else if (item?.learninguniqueid && item?.submitted === false) {

            navigate(`/editfellowshipmodule/${item?.moduleid}`, {
                state: { learninguniqueid: item?.learninguniqueid ,pathologistid: item?.pathologistid}
            });
        }

        else {

             navigate(`/moduleinstructions/${item?.moduleid}`, {
                            state: { moduleType: "fellowship", moduleid: item?.moduleid,pathologistid: item?.pathologistid  }
                        });

            // navigate(`/moduleslibrary/${item?.moduleid}`);
            // navigate(`/fellowshipmodules/${item?.moduleid}`, {
            //     state: { pathologistid: item?.pathologistid}
            // });
        }

    };
    // Handler for Read More click
    const handleReadMore = (item) => {
        setModalContent(item.description);
        setActiveReadMoreModal(true);  // Open the modal
    };

    // Close the modal
    const handleCloseReadMoreModal = () => {
        setActiveReadMoreModal(false);
    };

    const loadRazorpay = async (buyModuleItem) => {

        try {
            let id = buyModuleItem?.id;
            let amount = Number(buyModuleItem?.cost) * 100;
            if (!id) {
                let res = await tmdbApi.modulePayments(buyModuleItem?.moduleid);
                id = res?.result?.razorpayOrder?.id;
                amount = res?.result?.razorpayOrder?.amount;
            }
            const paymentAmount = amount;
            const paymentCurrency = "INR";

            // const paymentKey = RAZORPAY_KEY_ID;
            const options = {
                key: razorpayKey,
                amount: paymentAmount,
                currency: paymentCurrency,
                display_currency: "INR",
                name: "Dadi",
                description: buyModuleItem?.name || "Module Payment",
                order_id: id,
                handler: async function (response) {
                    console.log(response);
                    // Handle success/error response here
                    let signature = response?.razorpay_signature;
                    // Fallback: try to get signature from window or other sources if not present
                    if (!signature && window?.razorpay_signature) {
                        signature = window.razorpay_signature;
                    }
                    // Always send signature, even if empty string
                    let obj = {
                        razorpay_payment_id: response?.razorpay_payment_id || "",
                        razorpay_order_id: response?.razorpay_order_id || "",
                        razorpay_signature: signature || "",
                    };
                    // Only treat as success if both payment_id and signature are present
                    const isPaymentSuccess = !!(response?.razorpay_payment_id && signature);
                    if (isPaymentSuccess) {
                        obj.message = "Payment successful";
                        let verificationData = await tmdbApi.verifyPayments(null, buyModuleItem?.moduleid, JSON.stringify(obj),id);
                        if (
                            response?.razorpay_order_id &&
                            verificationData?.result?.transactionid &&
                            verificationData?.statusCode === 200
                        ) {
                            navigate(`/usermoduleslibrary/${buyModuleItem?.moduleid}?buy=1`);
                        } else {
                            setErrorMsg(true);
                            return;
                        }
                    } else {
                        // Add error reason if available
                        let reason = response?.error || response?.reason || "Payment failed or was cancelled.";
                        let failed = {
                            message: `Payment failed: ${reason}`,
                        };
                        await tmdbApi.verifyPayments(null, buyModuleItem?.moduleid, JSON.stringify(failed),id,"FAILED");
                        setErrorMsg(true);
                        return;
                    }


                },
                prefill: {
                    name: localStorage.getItem("name") || "User Name",
                    email: localStorage.getItem("email") || "",
                    contact: localStorage.getItem("contact") || "9999999999",
                },
                notes: {
                    address: localStorage.getItem("email"),
                },
                theme: {
                    color: "#3399cc",
                },
                modal: {
                    ondismiss: async function () {
                        // Handle payment modal close/cancel
                        let failed = {
                            message: `Payment Cancelled`,
                        };
                        await tmdbApi.verifyPayments(null, buyModuleItem?.moduleid, JSON.stringify(failed),id,"CANCELLED");
                        setErrorMsg(true);
                        return;
                    }
                }
            };
            if (window.Razorpay) {
                const rzp = new window.Razorpay(options);
                rzp.open();
            } else {
                alert("Razorpay SDK not loaded");
            }
        } catch (err) {
            alert("Failed to initiate payment");
            console.error(err);
        }
    };
    const handleBuyModule = async () => {
        await loadRazorpay(buyModuleItem);
        // if (buyModuleItem) {
        //     localStorage.setItem("moduleid", buyModuleItem?.moduleid);
        //     localStorage.setItem("selectedCost", buyModuleItem?.cost);
        //     navigate(`/moduleslibrary/${buyModuleItem?.moduleid}?buy=1`);
        // }
        setShowBuyAlert(false);
        setBuyModuleItem(null);
    };

    const handleGoToSubscription = () => {
        if (buyModuleItem) {
            // localStorage.setItem("moduleid", buyModuleItem?.moduleid);
            localStorage.setItem("selectedCost", buyModuleItem?.cost);
            navigate("/subscription");
        }
        setShowBuyAlert(false);
        setBuyModuleItem(null);
    };

    const handleHistory = (item) => {
        console.log('itemmmmmmmmmmm', item)
        navigate(`/history/${item?.moduleid}`, {
            state: { moduleType: item?.submodule }   // pass fellowship here
        });
    };
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            {razorpayKey && showBuyAlert && buyModuleItem && (
                <div className="buy-module-alert">
                    <SweetAlert
                        showCancel
                        confirmBtnText={`Buy Module`}
                        cancelBtnText="Go to Subscription"
                        title="Buy Module"
                        onConfirm={handleBuyModule}
                        onCancel={handleGoToSubscription}
                        customButtons={[
                            <button
                                key="buy"
                                className="btn btn-primary"
                                onClick={handleBuyModule}
                            >
                                Buy Module
                            </button>,
                            <button
                                key="close"
                                className="btn btn-primary btn-secondary"
                                style={{ marginLeft: 8 }}
                                onClick={() => {
                                    setShowBuyAlert(false);
                                    setBuyModuleItem(null);
                                }}
                            >
                                Cancel
                            </button>
                        ]}
                        onClose={() => {
                            setShowBuyAlert(false);
                            setBuyModuleItem(null);
                        }}
                    >
                        <span>
                            Buy this module for ₹100 or explore our full
                            <a onClick={() => navigate("/subscription")} style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}> subscription</a> for unlimited access.
                        </span>
                    </SweetAlert>
                </div>
            )}

            <div className="p-4 video-section-wrapper">
                {/* Subscription Dates */}

                <div className="row align-items-center breadcrumb mb-4" id="breadcrumb-row">
                    <div className="col-lg-6 col-md-3">
                        <div className="d-flex align-items-start">
                            <div className="flex-grow-1">
                                <h4 className="mb-2 card-title" id="breadcrumb-title">Fellowship Modules</h4>
                                {/* <p className="menu-path" id="breadcrumb-path"><span>Learning Hub</span> / <b id="breadcrumb-action">Video Library</b></p> */}
                            </div>
                            <div>
                                {!token && (<a id="back-button" className="stroke-btn-style create-quiz-btn" onClick={() => backTpPrev()}>back</a>)}

                            </div>
                        </div>
                    </div>
                    {/* <div className="col-lg-6">
                        <div className="col-lg-12 mb-10">
                            {usrData?.subscriptionStartDate && usrData?.subscriptionEndDate && (
                                <div className="d-flex justify-content-end gap-5">
                                    <div className="sub-active"><strong>Subscription Active :</strong></div>
                                    <div className="d-flex gap-3">
                                        <div>Start Date: <b className="sub-active">{new Date(usrData.subscriptionStartDate).toLocaleDateString()}</b> </div>
                                        <div>End Date: <b className="sub-active">{new Date(usrData.subscriptionEndDate).toLocaleDateString()}</b></div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> */}
                    <section className="fellow-subscription-status col-lg-6 col-md-9">
                        <div className="subscription-card">
                            {!isNaN(new Date(usrData?.subscriptionStartDate)) &&
                                !isNaN(new Date(usrData?.subscriptionEndDate)) && (
                                    <div>
                                        <span className="status-badge text-center">Subscription Active</span>
                                    </div>
                                )}
                            <div className="subscription-dates text-center d-flex gap-3 align-items-center">
                                <div>
                                    Start Date: 
                                    <strong className="sub-active">
                                        {" "}{formatDate(usrData?.subscriptionStartDate)}
                                    </strong>
                                </div>

                                <div>
                                    End Date: 
                                    <strong className="sub-active">
                                        {" "}{formatDate(usrData?.subscriptionEndDate)}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>



                {/* Tags & Search */}
                {/* { data && data.length > 0 && */}
                <div className="row align-items-center mb-4 video-library">
                    <div className="col-lg-8">
                        <TagCarousel />
                    </div>
                    <div className="col-lg-4 user-management video-search-bar">
                        <div className="table-data">
                            <div className="search-box mb-2 d-inline-block" id="search-box">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search modules..."
                                        value={inputQuery}
                                        onChange={e => setInputQuery(e.target.value)}
                                        id="search-input"
                                    />
                                    <button className="fill_btn" onClick={submitData} id="search-btn">
                                        <span className="material-icons search-icon">search</span>
                                    </button>
                                </div>
                                <div className="dataTables_length" id="datatable-length-reset">
                                    <button className="fill_btn" onClick={clearSearch} id="reset-btn">
                                        <span className="material-icons-outlined">sync</span>Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div><div className="text-sm-end" id="text-end"></div>
                </div>
                {/* } */}

                {/* Video Cards */}
                <div className="mt-3">
                    {!isLoading && data.length > 0 ? <>
                        <div className="row video-grid">
                            {
                                data.map((item) => {
                                    const videoId = getYouTubeVideoId(item.youtube);

                                    return (
                                        <div className="col-lg-3 col-md-6 mb-4" key={item._id}>
                                            <a className="text-decoration-none text-dark">
                                                <div className="video-card"
                                                >
                                                    {
                                                        img && item?.modulefiles?.length > 0 && item?.modulefiles[0]?.sourcepath
                                                            ? (
                                                                <img
                                                                    src={`${img}${item.modulefiles[0].sourcepath.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                    alt=""
                                                                />
                                                            )
                                                            : (
                                                                <img src="assets/images/module-default-img.svg" alt="" />
                                                            )
                                                    }

                                                    {/* <img src={`https://img.youtube.com/vi/${videoId}/0.jpg`} alt="Thumbnail" /> */}
                                                    {/* {item?.cost===0&&<button className="play-btn">
                                                    <span className="material-symbols-outlined">
                                                       visibility

                                                    </span>
                                                </button> } */}
                                                    <button className="play-btn" onClick={() => handleUserClick(item)}>
                                                        <span className="material-symbols-outlined">
                                                            open_in_new

                                                        </span>
                                                    </button>




                                                </div>
                                                <div>



                                                    <div className="d-flex justify-content-between align-items-center mt-3 module-card">
                                                        <a className="video-title mb-0" onClick={() => handleUserClick(item)}>{item?.name}</a>
                                                      {item?.participated &&   <button className="btn-fill-icon d-flex align-items-center buy-btn" onClick={() => handleHistory(item)}>
                                                            Submissions
                                                        </button>
                                                        }

                                                    </div>

                                                    <p className="video-para mt-2 mb-0">{<div dangerouslySetInnerHTML={{ __html: item?.description }} />
                                                        || "sample module desc"}</p>
                                                    {/* <p className="video-para mt-2 mb-0">{item?.description}</p> */}
                                                    {item?.description?.length > 200 && (
                                                        <div className="video-link mt-0"
                                                            style={{
                                                                cursor: 'pointer',          // Hand cursor on hover
                                                                // color: '#007bff',            // Blue text color
                                                                textDecoration: 'underline'  // Underline text to resemble a link
                                                            }} onClick={() => handleReadMore(item)}>Read more ...</div>
                                                    )}
                                                    <div className="d-flex justify-content-between">
                                                        <div className="d-flex gap-2 video-stats">
                                                            <span>{item?.time}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    );
                                })
                           }
                        </div>
                    </> : isLoading ? <Loader /> : !isLoading && data.length <= 0 ? <>
                      <div className="empty-state-body empty-record">
                                    <div className="empty-state__message" style={{ textAlign: "center" }}>
                                        <span className="material-icons"> widgets </span>
                                        {usrData?.subscriptionplanid ? <p className="form-check font-size-16" >
                                            Thanks for your subscription. Your modules will be assigned soon.
                                        </p> : <p className="form-check font-size-16" >
                                            Currently, you have not yet subcribed. Please check our <a onClick={() => navigate("/subscription")} className="fellow-sub"> subscription</a> plans for access.
                                        </p>}

                                    </div>
                                </div></>:<></>}

                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                        <nav>
                            <ul className="pagination">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>Prev</button>
                                </li>
                                {[...Array(totalPages)].map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(index + 1)}>
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                )}
            </div>
            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            <Modal
                className="access-code-popup module-description-modal"
                show={activeReadMoreModal}
                // backdrop="static"
                backdrop="true"
                centered
                onHide={handleCloseReadMoreModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Module Description</Modal.Title>
                    <span className="material-icons close-icon" onClick={handleCloseReadMoreModal}>close</span>
                </Modal.Header>

                <Modal.Body>
                    <div className="access-code-body">
                        <div className="form-group feebback-box">
                            {/* Rendering the rich HTML content inside the modal */}
                            <div className="modal-description"
                                dangerouslySetInnerHTML={{ __html: modalContent }}  // This renders HTML content
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <SweetAlert
                show={errorMsg}
                custom
                customclassName="cpc-alert"
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title="payment failed or cancelled"
                onConfirm={() => okayErrorFn()}
                id="error-alert"
            />
        </>
    );
};

export default FM;